var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("table", [
        _vm._m(0),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Name")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.getProperty(["name"])))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Description")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.getProperty(["description"])))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("URL")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.getProperty(["url"])))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Year Founded")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.getProperty(["year_founded"])))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Logo")]),
          _vm._v(" "),
          _c("td", [_c("img", { attrs: { src: _vm.getProperty(["logo"]) } })])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Cover Photo")]),
          _vm._v(" "),
          _c("td", [
            _c("img", { attrs: { src: _vm.getProperty(["cover_photo"]) } })
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Last Updated")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.getProperty(["updated_at"])))])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Countries")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(1),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_countries"]), function(country) {
            return country.country
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(country.country.name))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(country.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Sectors")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(2),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_sectors"]), function(sector) {
            return sector.sector
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(sector.sector.name))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(sector.relevancy))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(sector.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Capital Types")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(3),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_capital_types"]), function(
            capitalType
          ) {
            return capitalType.capital_type
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(capitalType.capital_type.name))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(capitalType.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Provider Types")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(4),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_provider_types"]), function(
            providerType
          ) {
            return providerType.provider_type
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(providerType.provider_type.name))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(providerType.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Languages")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(5),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_languages"]), function(languages) {
            return languages.language
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(languages.language.name))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(languages.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Currencies")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(6),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_currencies"]), function(
            providerCurrency
          ) {
            return providerCurrency.currency
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(providerCurrency.currency.name))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(providerCurrency.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Social Media")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(7),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_social_medias"]), function(
            providerSocialMedia
          ) {
            return providerSocialMedia.social_media
              ? _c("tr", [
                  _c("td", [
                    _vm._v(_vm._s(providerSocialMedia.social_media.name))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(providerSocialMedia.url))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(providerSocialMedia.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Stats")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(8),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_stats"]), function(providerStat) {
            return providerStat.stat
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(providerStat.stat.name))]),
                  _vm._v(" "),
                  providerStat.stat &&
                  providerStat.stat.code == "board_seat_binary"
                    ? _c("td", [
                        _vm._v(
                          "\n        " +
                            _vm._s(providerStat.value == 1 ? "yes" : "no") +
                            "\n      "
                        )
                      ])
                    : _c("td", [
                        _vm._v(
                          "\n        " + _vm._s(providerStat.value) + "\n      "
                        )
                      ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(providerStat.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Descriptions")]),
      _vm._v(" "),
      _c(
        "table",
        [
          _vm._m(9),
          _vm._v(" "),
          _vm._l(_vm.getProperty(["provider_descriptions"]), function(
            providerDesc
          ) {
            return providerDesc.description
              ? _c("tr", [
                  _c("td", [_vm._v(_vm._s(providerDesc.description.name))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(providerDesc.value))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(providerDesc.updated_at))])
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.getProperty(["contacts"]), function(contact, index) {
        return _c("div", [
          _c("hr"),
          _vm._v(" "),
          _c("h4", [_vm._v("Contact " + _vm._s(index + 1))]),
          _vm._v(" "),
          _c("table", [
            _c("tr", [
              _c("th", [_vm._v("Last updated")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(contact.updated_at))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Title")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(contact.title))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Name")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(contact.name))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Email")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(contact.email))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Phone Number")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(contact.phone_number))])
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _vm._l(_vm.getProperty(["offices"]), function(office, index) {
        return _c("div", [
          _c("hr"),
          _vm._v(" "),
          _c("h4", [_vm._v("Office " + _vm._s(index + 1))]),
          _vm._v(" "),
          _c("table", [
            _c("tr", [
              _c("th", [_vm._v("Last updated")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(office.updated_at))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("address_line_1")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(office.address_line_1))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("address_line_2")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(office.address_line_2))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("address_line_3")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(office.address_line_3))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("city")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(office.city))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("zip_code")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(office.zip_code))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("coordinates")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(office.coordinates))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("country")]),
              _vm._v(" "),
              _c("td", [
                office.country
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(office.country.name) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _vm._l(_vm.getProperty(["relationships"]), function(deal, index) {
        return _c("div", [
          _c("hr"),
          _vm._v(" "),
          _c("h4", [_vm._v("Deal " + _vm._s(index + 1))]),
          _vm._v(" "),
          _c("table", [
            _vm._m(10, true),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v(_vm._s(deal.jdoc.amount))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(deal.jdoc.year))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(deal.jdoc.source))])
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("table", [
            _vm._m(11, true),
            _vm._v(" "),
            _c(
              "td",
              _vm._l(deal.jdoc.investors, function(investor) {
                return _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getInvestorById(investor)) +
                      "\n        "
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "td",
              _vm._l(deal.jdoc.investees, function(investee) {
                return _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getInvesteeById(investee)) +
                      "\n        "
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("tr")
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Field")]),
      _vm._v(" "),
      _c("th", [_vm._v("Value")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("countries")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last Updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Sectors")]),
      _vm._v(" "),
      _c("th", [_vm._v("Relevancy")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last Updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last Updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last Updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last Updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Url")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Value")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Value")]),
      _vm._v(" "),
      _c("th", [_vm._v("Last updated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Amount")]),
      _vm._v(" "),
      _c("th", [_vm._v("Year")]),
      _vm._v(" "),
      _c("th", [_vm._v("Source")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Investors")]),
      _vm._v(" "),
      _c("th", [_vm._v("Investees")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72fc3283", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72fc3283","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/display.vue
// module id = 170
// module chunks = 0